import { useCallback } from 'react';

export const useDownloadFile = () =>
  useCallback((fileName: string, filePath: string) => {
    const fileUrl = `${filePath}`;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);
